/* eslint-disable
    no-unused-vars,
    prefer-const,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// some general purpose summon utilities
// please try to keep this as clear of dependencies as possible
// (or at least make sure they will work with the test suite without needing stubbing)

class UtilitiesService {
   constructor() {
      this.summonUnEscape = this.summonUnEscape.bind(this)
   }

   dateToFilterDate(date: any) {
      if (date && (typeof(date.getFullYear) === 'function')) {
         const yyyy = date.getFullYear().toString()
         let mm = (date.getMonth()+1).toString()
         let dd  = date.getDate().toString()
         if (mm.length < 2) {
            mm = "0" + mm
         }
         if (dd.length < 2) {
            dd = "0" + dd
         }
         return yyyy + '-' + mm + '-' + dd
      } else {
         return "*"
      }
   }

   summonEscape(s: any) {
      if (s == null) { s = '' }
      return s.replace(/(\,|\(|\)|\{|\}|\$|\:)/g, '\\$1')
   }

   summonEscapeWithParentesis(s: any) {
      if (s == null) { s = '' }
      return s.replace(/(\,|\{|\}|\$|\:)/g, '\\$1');
   }

   summonUnEscape(str: any) {
      if (str == null) { str = '' }
      return str.replace(/\\([\(\)\,\{\}\$\:])/g, '$1')
   }

   splitOnEscaped(str: any, splitChar: any) {
      if ((str == null)) {
         return ['']
      }
      if ((splitChar == null)) {
         return [str]
      }
      if (splitChar === '') {
         splitChar = str.split('')
      }
      if (splitChar.length > 1) {
         throw new Error("Only supports splitting on a single character or nothing")
      }

      const results = []
      let prevPos = 0
      for (let i = 0; i < str.length; i++) {
         var c = str[i]
         if ((c === splitChar) && (str[i - 1] !== '\\')) { // check for escape char
            results.push(str.substring(prevPos, i))
            prevPos = i + 1
         }
      }

      results.push(str.substring(prevPos))

      return results
   }

   titleCase(text: any) {
      if (text == null) { text = '' }
      return text.replace(/\w\S*/g, (s: any) => s.charAt(0).toUpperCase() + s.substring(1));
   }

   lowerCaseFirstChar(text: any) {
      if (text == null) { text = '' }
      return text.replace(/\w\S*/g, (s: any) => s.charAt(0).toLowerCase() + s.substring(1));
   }

   removeBoldTags(text: any) {
      if (text == null) { text = '' }
      return text.replace(/<\/?b(\sclass=".*?")?>/gi, '')
   }

   removeHithighlightTags(text: any) {
      if (text == null) { text = '' }
      return text.replace(/<\/?mark(\sclass=".*?")?>/gi, '')
   }

   getIIIUrlDetails(url: any, proxyUrl: any) {
      let proxyHost
      const iiiPattern = new RegExp(`\
https?://\
([^/?]*)\
(.*)\
`)
      let [x, host, tail] = url.match(iiiPattern);
      [x, proxyHost] = proxyUrl.match(iiiPattern)
      return [host, tail, proxyHost]
   }

   proxify(url: any, proxyInfo: any, isSummonUrl = false) {
      let host
      let proxyHost, tail
      if (!proxyInfo || !proxyInfo.url || !proxyInfo.type) { return url }
      const proxyUrl = proxyInfo.url
      if ((isSummonUrl === true) && (proxyInfo.type.toLowerCase() === "ezproxy")) { //filters summon vpn banner's links
         let all, deletedstring, protocol, searchquery
         const ezproxyPattern = new RegExp(`\
(https?\\://)\
([^/?]*)\
(.+?(?=#!)#!)\
(/.*)\
`);
         [all, protocol, host, deletedstring, searchquery] = url.match(ezproxyPattern)
         return `${proxyUrl}${protocol}${host}${searchquery}`
      }

      switch (proxyInfo.type.toLowerCase()) {
         case "iii": return (
            ([host, tail, proxyHost] = this.getIIIUrlDetails(url, proxyUrl)),
            `//0-${host}.${proxyHost}${tail}`
         )
         case "iii - wam ssl host replace": return (
            ([host, tail, proxyHost] = this.getIIIUrlDetails(url, proxyUrl)),
            url.indexOf('https') !== -1 ?  
               (host = host.split('.').join('-')) : undefined,
            `//0-${host}.${proxyHost}${tail}`
         )
         case "ezproxy": case "custom": case "acs": return `${proxyUrl}${url}`
         case "redirector": return `${proxyUrl}${encodeURIComponent(url).replace(/!/g, '%21')}` // https://docs.openathens.net/display/public/MD/Redirector+link+generator
         case "openathensredirector": return `${proxyUrl}?url=${encodeURIComponent(url).replace(/!/g, '%21')}`
         case "han": case "obvia": return `${proxyUrl}?title=Summon&url=${encodeURIComponent(url)}`
         default: return url
      }
   }
}
  

angular.module('summonApp.services')
   .service('utilitiesService', UtilitiesService)
